import { Component, Output, EventEmitter, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {
  @Output() loginClicked = new EventEmitter<void>();
  @Output() signupClicked = new EventEmitter<void>();
  router = inject(Router);
  selectedButton: 'login' | 'signup' | null = null;

  onLogin(): void {
    this.selectedButton = 'login';
    this.loginClicked.emit();
  }

  navigateToForm1(): void {
    this.selectedButton = 'signup';
    this.signupClicked.emit();
  }
}
